"use strict";
import React from "react";
import { Alert, Button } from "react-bootstrap";

const initComponent = (flex = window.flex) => {

    class Error extends React.Component {
        redirect = () => {
            const { redirect = "/" } = this.props;
            flex.redirect(redirect);
        }

        render() {
            const { heading = "ERROR", message = "An error has occured" } = this.props;
            return (
                <Alert bsStyle="danger">
                    <h4>{heading}</h4>
                    <p>{message}</p>
                    <hr />
                    <Button bsStyle="danger" onClick={this.redirect}>Click here to return to the Application</Button>
                </Alert>
            );
        }
    }

    return Error;
};

module.exports = initComponent;